// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"425":"18ffa946","459":"412c25bf"}[chunkId] + ".chunk.css";
};